import SlideDown from "../layout/SlideDown";

interface Props {
  error: string | Array<{ field: string | number | symbol; message: string }>;
  className?: string;
}

export default function InputError(props: Props) {
  const error = Array.isArray(props.error)
    ? props.error.map((item) => item.message).join(", ")
    : props.error;

  return (
    <SlideDown>
      {error && (
        <div className={`flex gap-2 pt-1 ${props.className}`}>
          <div className="">
            <i aria-hidden className="far fa-triangle-exclamation text-error" />
          </div>
          <div className="flex-1 font-bold">
            <>{error}</>
          </div>
        </div>
      )}
    </SlideDown>
  );
}
